import { Badge } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

export const NotInRoundBadge = ({ notInRound }: { notInRound?: boolean }) => {
  const { t } = useTranslation();
  if (!notInRound) return null;
  return (
    <Badge colorScheme="gray" title={t("Assessed on its latest tender from an earlier stage, since it delivered none in this round") ?? undefined}>
      {t("Earlier tender")}
    </Badge>
  );
};
